import { MutationTuple, useMutation } from '@apollo/client';
import { MilestoneStatusInput, UnApproveMilestonePayload } from '@bechtel/types';
import { UNAPPROVE_MILESTONE } from '@bechtel/client-gql';

export function useUnapproveMilestone(
  onActionCompleted?: () => void
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ unapproveMilestone: UnApproveMilestonePayload }, { input: MilestoneStatusInput }> {
  const response = useMutation<{ unapproveMilestone: UnApproveMilestonePayload }, { input: MilestoneStatusInput }>(
    UNAPPROVE_MILESTONE,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: () => {
        if (onActionCompleted) onActionCompleted();
      },
      onError: () => {
        if (onActionCompleted) onActionCompleted();
      },
    }
  );
  return response;
}
